module.exports = __webpack_public_path__ + "static/media/main.af4f48e0.svg";